/* =====================================================================
 * Régler Watches – automatische gratis producten + samengestelde horloges
 * ---------------------------------------------------------------------
 * Gratis producten (tags Free_product_<Naam>):
 *  1. Gereedschap is bandgebonden (stalen band → verstel-tool, mesh → mesh-tool).
 *  2. De travelbag is per horloge: een configuratie (kast + band met dezelfde
 *     line item property _rw_set) telt als één horloge en krijgt één zakje.
 *  3. Betaalde Hidden-producten (Luxury Giftbag) worden nooit aangeraakt.
 *
 * Samengestelde horloges (_rw_set):
 *  4. Verwijdert de klant de kast of de band, dan verdwijnt de hele samenstelling,
 *     inclusief giftbag. Gratis producten volgen daarna vanzelf.
 *  5. Verandert het aantal van kast of band, dan volgen de andere regels van die set.
 *     De giftbag is "passief": die telt wel mee bij verwijderen, maar het los
 *     verwijderen of aanpassen van de giftbag raakt de rest niet.
 *
 * window.RWGifts.reconcile() wordt door de configurator aangeroepen na toevoegen.
 * ===================================================================== */
(function () {
  'use strict';

  var FREE_MAP = {
    Free_product_Travelbag:        'free-luxury-travel-bag',
    Free_product_MeshToolSilver:   'free-mesh-tool-silver',
    Free_product_MeshToolGold:     'free-mesh-tool-gold',
    Free_product_MeshToolRoseGold: 'free-mesh-tool-rose-gold',
    Free_product_AdjustmentTool:   'free-watchstrap-adjustment-tool'
  };
  var BAG_TAG      = 'Free_product_Travelbag';
  var SET_PROPERTY = '_rw_set';
  var SET_PASSIVE  = ['regler-luxury-giftbag'];   // volgt de set, maar stuurt hem niet
  var FREE_HANDLES = Object.keys(FREE_MAP).map(function (k) { return FREE_MAP[k]; });
  var FREE_TAGS    = Object.keys(FREE_MAP);

  /* ---------- helpers ---------- */
  var tagCache = {};
  async function getProduct(handle) {
    if (tagCache[handle]) return tagCache[handle];
    try {
      var cached = sessionStorage.getItem('rw_prod_' + handle);
      if (cached) { tagCache[handle] = JSON.parse(cached); return tagCache[handle]; }
    } catch (e) {}
    var res = await fetch('/products/' + handle + '.js');
    if (!res.ok) return { tags: [], variantId: null };
    var p = await res.json();
    var data = { tags: p.tags || [], variantId: p.variants && p.variants[0] ? p.variants[0].id : null };
    tagCache[handle] = data;
    try { sessionStorage.setItem('rw_prod_' + handle, JSON.stringify(data)); } catch (e) {}
    return data;
  }
  function setIdOf(item) { var v = (item.properties || {})[SET_PROPERTY]; return v ? String(v) : ''; }
  async function fetchCart() { return (await fetch('/cart.js', { cache: 'no-store' })).json(); }
  async function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  /* ---------- samengestelde horloges ---------- */
  var lastSets = null;
  function snapshotSets(cart) {
    var sets = {};
    cart.items.forEach(function (it) {
      var id = setIdOf(it); if (!id) return;
      sets[id] = sets[id] || {};
      sets[id][it.key] = { qty: it.quantity, passive: SET_PASSIVE.indexOf(it.handle) !== -1 };
    });
    return sets;
  }
  // Vergelijkt met de vorige stand en herstelt de set-regel. Geeft true terug als er iets is gewijzigd.
  async function syncSets(cart) {
    var now = snapshotSets(cart);
    var changed = false;
    if (lastSets) {
      for (var setId in lastSets) {
        var prev = lastSets[setId], cur = now[setId] || {};
        var prevActive = Object.keys(prev).filter(function (k) { return !prev[k].passive; });
        var removed = prevActive.filter(function (k) { return !cur[k]; });
        var remaining = Object.keys(cur);
        if (removed.length && remaining.length) {
          // kast of band weg → hele samenstelling weg
          for (var i = 0; i < remaining.length; i++) { await changeLine(remaining[i], 0); changed = true; }
          continue;
        }
        // aantal van kast/band gewijzigd → rest van de set volgt
        var driver = prevActive.find(function (k) { return cur[k] && cur[k].qty !== prev[k].qty; });
        if (driver) {
          var q = cur[driver].qty;
          for (var k in cur) {
            if (k !== driver && cur[k].qty !== q) { await changeLine(k, q); changed = true; }
          }
        }
      }
    }
    return changed;
  }

  /* ---------- gratis producten ---------- */
  var running = false, rerun = false;

  async function reconcile() {
    if (running) { rerun = true; return; }
    running = true;
    try {
      var cart = await fetchCart();

      // eerst de sets kloppend maken, daarna pas gifts tellen
      if (await syncSets(cart)) cart = await fetchCart();
      lastSets = snapshotSets(cart);

      var needed = {}, present = {};
      FREE_HANDLES.forEach(function (h) { needed[h] = 0; present[h] = { qty: 0, lines: [] }; });
      var bagSets = {};

      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (FREE_HANDLES.indexOf(item.handle) !== -1) {
          present[item.handle].qty += item.quantity;
          present[item.handle].lines.push({ key: item.key, qty: item.quantity });
          continue;
        }
        var prod = await getProduct(item.handle);
        for (var t = 0; t < FREE_TAGS.length; t++) {
          var tag = FREE_TAGS[t];
          if (prod.tags.indexOf(tag) === -1) continue;
          if (tag === BAG_TAG) {
            var sid = setIdOf(item);
            if (sid) bagSets[sid] = Math.max(bagSets[sid] || 0, item.quantity);
            else needed[FREE_MAP[tag]] += item.quantity;
          } else {
            needed[FREE_MAP[tag]] += item.quantity;
          }
        }
      }
      Object.keys(bagSets).forEach(function (id) { needed[FREE_MAP[BAG_TAG]] += bagSets[id]; });

      var changed = false;

      var toAdd = [];
      for (var a = 0; a < FREE_HANDLES.length; a++) {
        var h = FREE_HANDLES[a], diff = needed[h] - present[h].qty;
        if (diff > 0) { var fp = await getProduct(h); if (fp.variantId) toAdd.push({ id: fp.variantId, quantity: diff }); }
      }
      if (toAdd.length) {
        var r = await fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: toAdd })
        });
        if (r.ok) changed = true; else console.warn('[RW gifts] toevoegen mislukt', await r.text());
      }

      for (var b = 0; b < FREE_HANDLES.length; b++) {
        var hh = FREE_HANDLES[b], surplus = present[hh].qty - needed[hh];
        if (surplus <= 0) continue;
        for (var l = 0; l < present[hh].lines.length && surplus > 0; l++) {
          var line = present[hh].lines[l], newQty = Math.max(0, line.qty - surplus);
          surplus -= (line.qty - newQty);
          await changeLine(line.key, newQty);
          changed = true;
        }
      }

      if (changed) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        if (/\/cart\/?$/.test(location.pathname)) location.reload();
      }
    } catch (e) {
      console.error('[RW gifts]', e);
    } finally {
      running = false;
      if (rerun) { rerun = false; reconcile(); }
    }
  }

  /* ---------- weergave gratis regels ---------- */
  var style = document.createElement('style');
  style.textContent = '.rw-free-line [class*="quantity"],.rw-free-line [class*="remove"],.rw-free-line a[href*="/cart/change"]{display:none !important;}';
  document.head.appendChild(style);
  function styleFreeLines() {
    var links = document.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      var handle = (href.split('/products/')[1] || '').split(/[?#\/]/)[0];
      if (FREE_HANDLES.indexOf(handle) === -1) continue;
      var row = links[i].closest('[data-key], .cart-item, .cart-drawer__item, .cart__item, li, tr');
      if (row) row.classList.add('rw-free-line');
    }
  }

  /* ---------- triggers ---------- */
  document.addEventListener('on:cart:add', reconcile);
  document.addEventListener('on:cart:after-merge', function () { reconcile(); styleFreeLines(); });
  document.addEventListener('on:cart-drawer:after-open', styleFreeLines);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reconcile(); styleFreeLines(); });
  } else { reconcile(); styleFreeLines(); }

  window.RWGifts = { reconcile: reconcile, SET_PROPERTY: SET_PROPERTY, FREE_MAP: FREE_MAP };
})();
